import Disinfector from './Disinfector';

export default Disinfector;